// 漳州下的区县
const zhangzhouRegion = [{
  'zh': '芗城区',
  'en': 'Xiangcheng District'
},
{
  'zh': '龙文区',
  'en': 'Longwen District'
},
{
  'zh': '龙海区',
  'en': 'Longhai District'
},
{
  'zh': '长泰区',
  'en': 'Changtai District'
},
{
  'zh': '漳浦县',
  'en': 'Zhangpu County'
},
{
  'zh': '云霄县',
  'en': 'Yunxiao County'
},
{
  'zh': '东山县',
  'en': 'Dongshan County'
},
{
  'zh': '诏安县',
  'en': 'Zhaoan County'
},
{
  'zh': '南靖县',
  'en': 'Nanjing County'
},
{
  'zh': '平和县',
  'en': 'Pinghe County'
},
{
  'zh': '华安县',
  'en': 'Huaan County'
},
{
  'zh': '台商投资区',
  'en': 'Taiwan Businessmen Investment Zone'
},
{
  'zh': '常山开发区',
  'en': 'Changshan Development Zone'
},
{
  'zh': '古雷开发区',
  'en': 'Gulei Development Zone'
},
{
  'zh': '漳州开发区',
  'en': 'Zhangzhou Development Zone'
},
{
  'zh': '漳州高新区',
  'en': 'Zhangzhou High-Tech Industrial Development Zone'
}]

const zhangzhouRegionFormat = (() => {
  const obj = {
    zh: [],
    en: []
  }
  for (const i in zhangzhouRegion) {
    obj.zh.push(zhangzhouRegion[i]['zh'])
    obj.en.push(zhangzhouRegion[i]['en'])
  }
  return obj
})()

export default zhangzhouRegionFormat
